import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class ModalService {

    constructor(private modalController: ModalController) { }

    // Method to present a modal with a dynamic component and optional props
    async presentModal(
        component: any, // The component type to load dynamically
        componentProps: any = {}, // Optional props for the component
        cssClass: string | null = null, // Optional CSS class for styling, default will be set if null
        backdropDismiss: boolean = true, // Dismiss when clicking outside
        showBackdrop: boolean = true // Show backdrop or not
    ): Promise<any> {
        const finalCssClass = cssClass ? cssClass : 'small-alert-modal'; // Set default if not provided

        const modal = await this.modalController.create({
            component,
            componentProps,
            cssClass: finalCssClass, // Apply dynamic or default class
            backdropDismiss,
            showBackdrop
        });

        await modal.present();

        // Wait for the modal to be dismissed
        const { data } = await modal.onWillDismiss();
        return data; // Return the modal's data
    }
}
